var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 59.98 71.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 65"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M40.84 55.12H14.96v-22.2m0-22.03V1.5h33.66l9.86 9.74v43.88h-6.71m4.43 4.75-9.91 9.92-9.91-9.92m9.91 8.99V42.79"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M1.5 12.22h38.72v20.03H1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "inherit",
    d: "M6.67 17.29a21 21 0 0 1 3.33-.22 5.2 5.2 0 0 1 3.2.8 3 3 0 0 1 1.15 2.43 3.26 3.26 0 0 1-1 2.49A5 5 0 0 1 10 23.85h-.66v3.42H6.67zm2.68 4.45a3 3 0 0 0 .62 0c1 0 1.71-.54 1.71-1.41s-.5-1.27-1.53-1.27a4 4 0 0 0-.8.07zm6.34-4.45a21 21 0 0 1 3.21-.22 6.87 6.87 0 0 1 4.15 1A4.41 4.41 0 0 1 24.88 22a5 5 0 0 1-1.76 4.16 7.76 7.76 0 0 1-4.74 1.24 18.4 18.4 0 0 1-2.69-.16zm2.7 7.93a3.4 3.4 0 0 0 .57 0c1.76 0 3.05-.94 3.05-3.21a2.6 2.6 0 0 0-2.79-2.9 4.3 4.3 0 0 0-.83.06zm7.94-8.07h6.48v2.21H29v1.86h3.55v2.18H29v3.84h-2.67z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdf);
export default __webpack_public_path__ + "static/media/downloadPdf.be5134e9844cf6fcaf64b2ab0a8ee677.svg";
export { ForwardRef as ReactComponent };